import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconosGenerales from "../../elementos/iconos/IconosGenerales";
import { visuallyHidden } from '@mui/utils';
import { styled } from '@mui/material/styles';
import PaginacionTabla from '../eventos/filtros/SelectPaginaTabla';
import SelectNumeroCursos from '../eventos/filtros/SelectNumeroElementos';
import Buscador from '../eventos/filtros/BuscadorDinamico';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomTooltip from './../eventos/avisos/Tooltip';
import BotonesAccion from "../../elementos/eventos/navegacion_y_accion/BotonesAccion";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Button } from 'react-bootstrap';
import { CircularProgress } from '@mui/material';
import ProtectedView from '../../providers/ProtectedView';
import { useContext } from 'react';
import { UsuarioContext } from '../../providers/personaContext';
const GEOAPI_KEY = process.env.REACT_APP_GEOAPIFY_API_KEY;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    textAlign: 'center  !important',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgba(0, 60, 102, 0.8)',
        color: theme.palette.common.white,
        padding: '0px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    textAlign: 'center  !important',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const WhiteTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    textAlign: 'center  !important',
    color: `${theme.palette.common.white} !important`,
    '&.Mui-active .MuiTableSortLabel-icon': {
        color: `${theme.palette.common.white} !important`,
    },
}));

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, header } = props;
    const createSortHandler = (property) => (event) => onRequestSort(event, property);

    const persona = useContext(UsuarioContext);
    const esAdmin = persona.persona?.rol?.toLowerCase() === 'administrador' || persona.persona?.rol?.toLowerCase() === 'super administrador';

    return (
        <TableHead>
            <StyledTableRow>
                {esAdmin && (
                    <StyledTableCell padding="checkbox">
                        <Checkbox
                            style={{ color: 'white' }}
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{ 'aria-label': 'select all' }}
                        />
                    </StyledTableCell>
                )}
                {header.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <WhiteTableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id && (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            )}
                        </WhiteTableSortLabel>
                    </StyledTableCell>
                ))}
            </StyledTableRow>
        </TableHead>
    );
}

function EnhancedTableToolbar({ numSelected, setEliminarSeleccion }) {
    const [estadoBusqueda, setEstadoBusqueda] = useState(false);
    const [escribiendo, setEscribiendo] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const busquedaParam = searchParams.get('busqueda') || '';

    const toggleSeleccion = (valor) => {
        setEliminarSeleccion((prevState) => ({ ...prevState, valor }));
    };

    const actualizarBusqueda = (valor) => {
        const params = new URLSearchParams(location.search);
        if (valor.trim()) {
            params.set('busqueda', valor);
        } else {
            params.delete('busqueda');
        }
        navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    };

    return (
        <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 }, ...(numSelected > 0 && {
            bgcolor: (theme) => alpha(theme.palette.common.white, theme.palette.action.activatedOpacity),
        }) }}>
            {numSelected > 0 ? (
                <Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1">
                    {numSelected} seleccionado(s)
                </Typography>
            ) : (
                <ProtectedView allowedRoles={["administrador", "super administrador"]}>
                    <Typography sx={{ flex: '1 1 40%' }} variant="h6">
                        <BotonesAccion texto="Crear Oficina" to="/gestionpersonas/oficinas/crearOficina" />
                    </Typography>
                </ProtectedView>

            )}

            {numSelected > 0 ? (
                <ProtectedView allowedRoles={["administrador", "super administrador"]}>
                    <CustomTooltip mensaje="Eliminar select">
                        <div onClick={() => toggleSeleccion(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', width: '40px', height: '40px' }}>
                            <IconosGenerales papeleraT="true" id="eliminarSelect" style={{ width: '40px', height: '40px' }} />
                        </div>
                    </CustomTooltip>
                </ProtectedView>
            ) : (
                <>
                    <Buscador
                        placeholder="Buscar Oficina"
                        tooltip="Ej: Nombre"
                        palabra={busquedaParam}
                        estadoBusqueda={estadoBusqueda}
                        setEstadoBusqueda={setEstadoBusqueda}
                        escribiendo={escribiendo}
                        setEscribiendo={setEscribiendo}
                        onBuscar={actualizarBusqueda}
                    />
                    <ProtectedView allowedRoles={["administrador", "super administrador"]}>
                        <BotonesAccion icono="delete" to="/gestionpersonas/oficinas" />
                    </ProtectedView>
                </>
            )}
        </Toolbar>
    );
}

function EnhancedTable(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const persona = useContext(UsuarioContext);
    const esAdmin = persona.persona?.rol?.toLowerCase() === 'administrador' || persona.persona?.rol?.toLowerCase() === 'super administrador';

    const {
        data, header, meta,
        selected, setSelected, eliminarSeleccion, setEliminarSeleccion
    } = props;

    const [abrirModal, setAbrirModal] = useState(false);
    const [oficinaSeleccionada, setOficinaSeleccionada] = useState(null);
    const [coordenadas, setCoordenadas] = useState(null);
    const [loadingMap, setLoadingMap] = useState(false);

    useEffect(() => {
        const fetchCoordenadas = async () => {
            if (!oficinaSeleccionada) return;

            setLoadingMap(true);
            setCoordenadas(null);

            const query = `${oficinaSeleccionada.direccion}, ${oficinaSeleccionada.poblacion}`;
            const url = `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(query)}&apiKey=${GEOAPI_KEY}&limit=1`
            //const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1`;

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (data && data.features) {
                    const lon = data.features[0].geometry.coordinates[0];
                    const lat = data.features[0].geometry.coordinates[1]
                    setCoordenadas({ lat, lon });
                } else {
                    console.warn("No se encontraron coordenadas para la dirección:", query);
                }
            } catch (error) {
                console.error("Error fetching coordinates:", error);
            } finally {
                setLoadingMap(false);
            }
        };

        fetchCoordenadas();
    }, [oficinaSeleccionada]);

    const orden = searchParams.get('orden') || 'asc';
    const ordenarColumna = searchParams.get('ordenarColumna') || 'nombre';

    const handleRequestSort = (event, property) => {
        const normalizedProperty = property.toLowerCase();
        const isAsc = ordenarColumna === normalizedProperty && orden === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';

        const params = new URLSearchParams(location.search);
        params.set('orden', newOrder);
        params.set('ordenarColumna', normalizedProperty);
        navigate({ pathname: location.pathname, search: params.toString() });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = data.map((n) => n.Id);
            setSelected(newSelected);
        } else {
            setSelected([]);
        }
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [...selected];
        if (selectedIndex === -1) {
            newSelected.push(id);
        } else {
            newSelected.splice(selectedIndex, 1);
        }
        setSelected(newSelected);
    };

    const handleRowClick = (event, row) => {
        if (event.target.type === 'checkbox' || 
            event.target.closest('button') || 
            event.target.closest('a')) {
            return;
        }
        setOficinaSeleccionada(row);
        setAbrirModal(true);
    };

    const handleCloseModal = () => {
        setAbrirModal(false);
        setOficinaSeleccionada(null);
    };

    const isSelected = (id) => selected.includes(id);
    const sortedData = data;

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '98%', mb: 2 }}>
                <EnhancedTableToolbar
                    numSelected={selected.length}
                    eliminarSeleccion={eliminarSeleccion}
                    setEliminarSeleccion={setEliminarSeleccion}
                />
                <TableContainer>
                    <Table sx={{ maxWidth: 2000, minWidth: 1300 }}>
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={orden}
                            orderBy={ordenarColumna}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={data.length}
                            header={header}
                        />
                        <TableBody>
                            {sortedData.map((row, index) => {
                                const isItemSelected = isSelected(row.Id);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <StyledTableRow
                                        hover
                                        onClick={(event) => handleRowClick(event, row)}
                                        sx={{ cursor: 'pointer' }}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.Id}
                                        selected={isItemSelected}
                                    >
                                        {esAdmin && (
                                            <StyledTableCell padding="checkbox">
                                                <Checkbox
                                                    color="default"
                                                    onClick={(event) => handleClick(event, row.Id)}
                                                    checked={isItemSelected}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                />
                                            </StyledTableCell>
                                        )}
                                        <StyledTableCell component="th" id={labelId} scope="row" padding="none">
                                            {row.nombre}
                                        </StyledTableCell>
                                        <StyledTableCell align="left">{row.direccion}</StyledTableCell>
                                        <StyledTableCell align="left">{row.provincia}</StyledTableCell>
                                        <StyledTableCell align="left">{row.poblacion}</StyledTableCell>
                                        {esAdmin ? (
                                            <StyledTableCell align="right">
                                                <IconosGenerales
                                                    tabla="true"
                                                    id="edit"
                                                    to={`/gestionpersonas/oficinas/editarOficina/${row.Id}`}
                                                />
                                            </StyledTableCell>
                                        ):
                                            <StyledTableCell></StyledTableCell>
                                        }
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <PaginacionTabla totalPages={meta.totalPages} />
            <SelectNumeroCursos perPage={meta.per_page || 10} />
            <Typography variant="body2" sx={{ textAlign: 'right', fontWeight: 'bold', fontSize: '16px', mt: -3, mr: '2%', color: 'rgba(0, 60, 102, 0.8)' }}>
                Total registros: {meta.total || 0}
            </Typography>
            <Dialog
                open={abrirModal}
                onClose={handleCloseModal}
                maxWidth="md"
                fullWidth
            >
                {oficinaSeleccionada && (
                    <>
                        <DialogTitle sx={{ m: 0, p: 2, bgcolor: '#336384', color: 'white' }}>
                            Detalles de {oficinaSeleccionada.nombre}
                            <IconButton
                                aria-label="close"
                                onClick={handleCloseModal}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: 'white',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        Información de la Oficina
                                    </Typography>
                                    <Divider sx={{ mb: 1 }} />
                                    <Typography><strong>Nombre:</strong> {oficinaSeleccionada.nombre}</Typography>
                                    <Typography><strong>Dirección:</strong> {oficinaSeleccionada.direccion}</Typography>
                                    <Typography><strong>Población:</strong> {oficinaSeleccionada.poblacion}</Typography>
                                    <Typography><strong>Provincia:</strong> {oficinaSeleccionada.provincia}</Typography>
                                    <Typography><strong>Código Postal:</strong> {oficinaSeleccionada.cp}</Typography>
                                    <br/>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        Contacto
                                    </Typography>
                                    <Divider sx={{ mb: 1 }} />
                                    <Typography><strong>Teléfono:</strong> {oficinaSeleccionada.telefono || 'No asignado'}</Typography>
                                    <Typography><strong>Email:</strong> {oficinaSeleccionada.email || 'No asignado'}</Typography>
                                    <br/>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        Horario
                                    </Typography>
                                    <Divider sx={{ mb: 1 }} />
                                    <Typography style={{ whiteSpace: 'pre-wrap' }}>
                                        {oficinaSeleccionada.horario || 'No asignado'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        Ubicación en Mapa
                                    </Typography>
                                    <Divider sx={{ mb: 1 }} />
                                    {loadingMap && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 350 }}><CircularProgress /></Box>}
                                    {!loadingMap && coordenadas && (
                                        <iframe
                                            width="100%"
                                            height="350"
                                            frameBorder="0"
                                            scrolling="no"
                                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${coordenadas.lon - 0.001},${coordenadas.lat - 0.001},${coordenadas.lon + 0.001},${coordenadas.lat + 0.001}&layer=mapnik&marker=${coordenadas.lat},${coordenadas.lon}`}
                                            style={{ border: '1px solid black' }}
                                            title={`Mapa de ${oficinaSeleccionada.nombre}`}
                                        ></iframe>
                                    )}
                                    {!loadingMap && !coordenadas && (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 350, border: '1px solid #ccc', borderRadius: '4px' }}>
                                            <Typography variant="body2" color="textSecondary">
                                                Mapa no disponible
                                            </Typography>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                style={{
                                    backgroundColor: "rgb(51,99,132)",
                                    borderColor: "rgb(51,99,132)",
                                    color: "white"
                                }}
                                onClick={handleCloseModal}
                            >
                                Cerrar
                            </Button>
                        </DialogActions>
                    </>
                )}
            </Dialog>
        </Box>
    );
}

EnhancedTable.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    eliminarSeleccion: PropTypes.object.isRequired,
    setEliminarSeleccion: PropTypes.func.isRequired,
};

export default EnhancedTable;
